import { z } from 'zod';

export const InviteSearchSchema = z.object({
  membershipType: z.enum(['operator', 'individual']).default('operator'),
  freeText: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),
  workerTypeIdIn: z.array(z.string()).optional(),
  placeIdIn: z.array(z.string()).optional(),
  joiningOnly: z.boolean().optional(),
  joiningDateFrom: z.string().optional(),
  joiningDateTo: z.string().optional(),
});
